module.exports = __webpack_public_path__ + "img/12.40235c79.png";